import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class UserExternalLink extends RestApiModel {

  static getResourceEndpoint() {
    return '/user/external-link';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default UserExternalLink;
